<template>
  <div class="pannel01">
    <div class='data-tab'>
      <el-tabs style='float: left' v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="文章数" name="article"></el-tab-pane>
        <el-tab-pane label="阅读量" name="read"></el-tab-pane>
        <el-tab-pane label="评论数" name="comment"></el-tab-pane>
      </el-tabs>


      <div class="block" style="float: right;padding:5px 15px">
        <el-date-picker
          v-model="value6"
          type="daterange"
          size="small"
          @change='fn'
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>

      <el-tabs style='float: right;' v-model="activeName2" @tab-click="handleClick">
        <el-tab-pane label="今日" name="hour"></el-tab-pane>
        <el-tab-pane label="本周" name="day1"></el-tab-pane>
        <el-tab-pane label="本月" name="day2"></el-tab-pane>
        <el-tab-pane label="全年" name="month"></el-tab-pane>
      </el-tabs>

    </div>
    <div id="curve_show" class="curve_show"></div>
  </div>
</template>

<script>
import cons from '@/components/constant'
export default {
  name: 'CurveGraph',
  data () {
    return {
      activeName: 'article',
      activeName2: 'month',
      value6: []

    }
  },
  methods: {
    fn(){
      this.initData('day')
    },
    returnStr(en){
      var str = ''
      if(en === 'article'){
        str = '文章数'
      }else if(en === 'read'){
        str = '阅读量'
      }else if(en === 'comment'){
        str = '评论数'
      }
      return str
    },
    format(date_obj){
      var y = date_obj.getFullYear()
      var m = date_obj.getMonth()+1
      var d = date_obj.getDate()
      m = m < 10 ? '0'+m:m
      d = d < 10 ? '0'+d:d
      return y+'-'+m+'-'+d
    },
    getMondayDate(now_time){
      // 获取年月日星期
      var w = now_time.getDay()  // 0-6
      var d = now_time.getDate()  // 1-31
      var m = now_time.getMonth()+1  // 0-11
      var y = now_time.getFullYear()

      // 星期日处理
      if(w===0){
        w=7
      }

      // 判断是否跨月份
      if(d-w+1>0){
        d = d - w +1
      }else{
        // 判断是否跨年
        if(m === 1){
          m = 12
          y = y-1
          d = 31-d-w+1
        }else if(m === 3){
          if(y%4==0&&y%100!=0||y%400==0){
            d = 29-d-w+1
          }else{
            d = 28-d-w+1
          }
          m = m-1
          y = y-1
        }else if(m===2||m===4||m===6||m===8||m===9||m===11){
          m = m-1
          y = y-1
          d = 31-d-w+1
        }else if(m===5||m===7||m===10||m===12){
          m = m-1
          y = y-1
          d = 30-d-w+1
        }
      }
      return new Date(y, m-1, d)
    },
    handleClick(tab, event) {
      this.initData(this.activeName2)
    },
    initData(date_type){
      let token = localStorage.token;
      var data_type2 = date_type
      if(date_type.indexOf('day')===0){
        data_type2 = 'day'
        var now_time = new Date()
        if(date_type === 'day1'){
          this.value6 = [this.getMondayDate(now_time), now_time]
        }else if(date_type === 'day2'){
          this.value6 = [new Date(now_time.getFullYear()+"-"+(now_time.getMonth()+1)+'-'+1), now_time]
        }
      }else if(date_type === 'hour'){
        this.value6 = [new Date(), new Date()]
      }

      // 获取月  网站访问量
      this.axios.get(cons.apis + '/v1_0/statistics_basic', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            type: 'access',
            begin: this.value6[0]?this.format(this.value6[0]):'',
            end: this.value6[1]?this.format(this.value6[1]):'',// date 结束时间(闭区间) '2019-2-1'
            size: data_type2
          }
      })
      .then(dat=>{
          let aList_all = dat.data.data;
          let aCount = [];
          let aDate = [];


          if(date_type === 'month'){
            var now_month = new Date().getMonth() + 1
            for(var i=0;i<aList_all.length;i++){
                // aDate.push(aList_all[i].date);
                if(aList_all[i].month <= now_month){
                  aCount.push(aList_all[i].count);
                  aDate.push(aList_all[i].month);
                }
            }
            // aCount = [54, 55, 24, 2, 6, 34, 6, 23, 65, 23, 22, 31]
          }else if(date_type === 'hour'){
            var now_hour = new Date().getHours()
            for(var i=0;i<aList_all.length;i++){
                // aDate.push(aList_all[i].date);
                if(aList_all[i].date_time.slice(11, 13)*1 <= now_hour){
                  aCount.push(aList_all[i].count);
                  aDate.push(aList_all[i].date_time.slice(11, 13));
                }
            }
            // aCount = [11, 22, 33, 21, 16, 34, 16, 23, 65, 23, 22, 31,11, 22, 33, 21, 16, 34, 16, 23, 65, 23, 22, 31]
          }else{
            for(var i=0;i<aList_all.length;i++){
              aCount.push(aList_all[i].count);
              aDate.push(aList_all[i].date.slice(5));
            }
            // aCount = [11, 22, 33, 21, 16, 34, 16, 23, 65, 23, 22, 31,11, 22, 33, 21, 16, 34, 16, 23, 65, 23, 22, 31]

          }




          let oCurve = this.echarts.init(document.getElementById('curve_show'));
          let oCurveopt =
                  {
                    title:{
                        text: this.returnStr(this.activeName),
                        left: 'center',
                        top: '10'
                    },
                    tooltip:{
                        trigger: 'axis'
                    },
                    // legend: {
                    //     data:['active'],
                    //     top: '40'
                    // },
                    toolbox: {
                        show : true,
                        feature : {
                            mark : {show: true},
                            dataView : {show: true, readOnly: false},
                            magicType : {show: true, type: ['line','bar']},
                            restore : {show: true},
                            saveAsImage : {show: true}
                        }
                    },
                    calculable : true,
                    xAxis : [
                        {
                            name: data_type2,
                            type : 'category',
                            boundaryGap : false,
                            data : aDate
                        }
                    ],
                    yAxis : [
                        {
                            name: this.returnStr(this.activeName)+'趋势',
                            type : 'value'
                        }
                    ],
                    series : [
                        {
                            name:'active',
                            type:'line',
                            smooth:true,
                            lineStyle: {color: '#f80'},
                            data:aCount,
                            areaStyle:{
                              normal:{
                                  color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                      offset: 0,
                                      color: 'rgba(255,136,0,0.39)'
                                  }, {
                                      offset: 0.34,
                                      color: 'rgba(255,180,0,0.25)'
                                  },{
                                      offset: 1,
                                      color: 'rgba(255,222,0,0.00)'
                                  }])
                              }
                          }
                    }],
                    grid: {
                        show: true,
                        x:50,
                        x2:50,
                        y:80,
                        height:220
                    }

                  };
                oCurve.setOption(oCurveopt);

      }).catch(err=>{
         console.log(err);
      });

    }
  },
  mounted(){
    this.initData(this.activeName2)
  }
}
</script>

<style scoped>
.pannel01{
  width:95%;
  overflow:hidden;
  margin:20px auto 0;
  background-color:#fff;
  float:left;
  margin-left:2.4%;
}
.curve_show{
  width:100%;
  height:350px;
}

.data-tab {
  height: 40px;
  padding-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/widget/CurveGraphTwo.vue